import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import apiClient from "../../../api/apiClient";
import { handleErrors } from "../../../modules/handleErrors";
import { toast } from "react-toastify";

export const DeleteModal = ({
  showRemove,
  modalCloseRemove,
  mocko_id,
  fetchFeaturedMockups,
  isBundleRemove,
  fetchBundleMockups,
  viewMode,
   fetchAllDetails
}) => {
  const [Loader, setLoader] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      let response;
      if (isBundleRemove) {
        response = await apiClient.delete(`/bundle-listings/${mocko_id}/`);
      } else {
        response = await apiClient.delete(`/listings/${mocko_id}/`);
      }
      setLoader(false);

      if (!response.ok) return handleErrors(response.data);
      toast.success("Product deleted successfully");

      
        if (viewMode === "detailed") {
        fetchAllDetails();
      } else {
        if (isBundleRemove) {
          fetchBundleMockups();
        } else {
          fetchFeaturedMockups();
        }
      }
      modalCloseRemove();
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <Modal
      show={showRemove}
      onHide={modalCloseRemove}
      dialogClassName="alert-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "40px 30px",
          background: "#F8D4B7",
          borderTopRightRadius: "24px",
          borderBottomLeftRadius: "24px",
        }}
      >
        <section className="text-center">
          {isBundleRemove ? (
            <p>Are you sure you want to delete this bundle?</p>
          ) : (
            <p>Are you sure you want to delete?</p>
          )}
          <div>
            <button
              disabled={Loader}
              className="btn grey-btn mb-3 px-5"
              style={{
                width: "190px",
                paddingTop: "8px",
                paddingBottom: "8px !important",
              }}
              onClick={handleDelete}
            >
              {Loader ? "I'm Sure..." : "I'm Sure"}
            </button>
          </div>

          <div>
            <button
              className="btn bg-white px-5"
              style={{ width: "190px", border: "2px solid #000" }}
              onClick={modalCloseRemove}
            >
              Cancel
            </button>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};

